export const props = { viewBox: "0 0 26 24" };
export const innerHTML = '<rect x="12.9706" y="0.970581" width="17.0122" height="17.0122" transform="rotate(45 12.9706 0.970581)" fill="#EF7200"/>';
